export const HOST = "https://airomnishopback.devssh.xyz";
